const links = {
  "links.CLI_repository": "https://cli.akeneo.cloud/",
  "links.blackfire.connect": "https://blackfire.io/session/connect/akeneo",
  "links.documentation.download_code": "",
  "links.documentation.wizard": "",
  "links.website": "https://akeneo.com"
};

export default links;
